<template>
  <div id="app">
    <router-link to="/login"></router-link>
  </div>
  <router-view/>
</template>


<style lang="scss">
@use './assets/css';
</style>
